export const LAYERED_EDIT_WARNING = "Layer split was not an exact match. Compare carefully before saving.";
export const LAYERED_EDIT_MAX_BASELINE_DIFF = 0.08;
export type LayerBox = { x: number; y: number; width: number; height: number };
export type LayerStyle = {
  border_radius_percent?: 50;
  border_color?: string;
  border_width_px?: number;
  background_color?: string;
  border_radius_px?: number;
  border_radius_corners_px?: [number, number, number, number];
  background_gradient?: { kind: "linear"; angle_deg: number; stops: { offset: number; color: string }[] };
  box_shadow?: { offset_x_px: number; offset_y_px: number; blur_px: number; spread_px: number; color: string; inset: boolean };
};
export type LayerTextStyle = {
  padding_px?: [number, number, number, number];
  font_family: string; font_size_px: number; font_weight?: number; color?: string;
  letter_spacing_px?: number; text_align?: "left" | "center" | "right"; line_height?: number;
  uppercase?: boolean; underline?: boolean; no_wrap?: boolean; italic?: boolean;
};
export type AdLayer = {
  id: string; type: "text" | "image" | "vector"; subtype?: string;
  hidden?: boolean;
  bbox: LayerBox; z_order: number; asset_path?: string; text?: string;
  style?: LayerStyle; text_style?: LayerTextStyle; image_fit?: { object_fit: "cover" | "contain" | "fill" };
};
export type LayerEdits = Record<string, { text?: string; hidden?: boolean; bbox?: LayerBox; zOrder?: number }>;
export function isLayerHidden(layer: AdLayer, edit?: LayerEdits[string]) {
  return edit?.hidden ?? layer.hidden ?? false;
}
export function layerCanBeShown(layer: AdLayer) {
  return layer.type !== "text" || !!layer.text_style?.color;
}
export type LayerFontAsset = { url: string; family: string; weight?: string };
export type LayeredDecompositionView = {
  id: string; canvasWidth: number; canvasHeight: number; layers: AdLayer[]; fontAssets?: LayerFontAsset[];
  cached: boolean; falLatencyMs: number | null;
};
export type LayeredCanvasTelemetry = {
  moves: number; resizes: number; reorders: number; deletes: number; textEdits: number; undos: number; resets: number;
};
export type LayeredRenderResult = {
  jobId: string; image_url: string; decompositionId: string;
  baselineDiff: number; lowFidelity: boolean; fontFallback: boolean;
};
